import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import router from './router'
import store from './store'
import './utils/windowOpen' 
// 引入样式
import "vue-easytable/libs/theme-default/index.css";
// 引入组件库
import VueEasytable from "vue-easytable";

Vue.use(VueEasytable);
import './style/element.less'
import './style/base.less'
import echarts from "echarts";
import {Message} from 'element-ui';
import {UPLOAD_URL} from './conifg'
import '@/common/font/font.css'
import 'xe-utils'
import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'
import {getTokenLogin} from "@/api";
import {setToken, getToken} from "@/utils/auth";
import {setMenuInfoPath} from "@/utils/pageRouter";
//全局涨跌幅组件 floatPrice
import floatPrice from "@/components/floatPrice/index.vue"; 
Vue.component('FloatPrice', floatPrice);
Vue.use(VXETable)

import './permission' // permission control

Vue.prototype.$echarts = echarts;
Vue.prototype.$downloadUrl = UPLOAD_URL
Vue.prototype.$setMenuInfoPath = setMenuInfoPath

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(VueRouter).use(ElementUI)
//定义一个新的Message方法，多传入一个offset参数
const $message = options => {
    return Message({
        ...options,
        offset: 100
    });
};

//重写一遍success的方法,将offset写入options
['success', 'warning', 'info', 'error'].forEach(type => {
    $message[type] = options => {
        if (typeof options === 'string') {
            options = {
                message: options,
                offset: 100
            };
        }
        options.type = type;
        return Message(options);
    };
});
//将$message挂载到this上
Vue.prototype.$message = $message;
Vue.prototype.openLoading = function () {
    const loading = this.$loading({
        lock: true,
        text: 'loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.8)',
        target: ' .table-flex, .region',
        fullscreen: true,
        customClass: 'loadingclass'
    })
    setTimeout(function () {                  // 设定定时器，超时10S后自动关闭遮罩层，避免请求失败时，遮罩层一直存在的问题
        loading.close();
    }, 100000)
    return loading;
}

Vue.config.productionTip = false

// 百度统计
var _hmt = _hmt || [];
window._hmt = _hmt;
(function() {
  var hm = document.createElement("script");
  hm.src = "https://hm.baidu.com/hm.js?cc5d4b0605a27ac90daab625c232fe26";
  var s = document.getElementsByTagName("script")[0]; 
  s.parentNode.insertBefore(hm, s);
})();

router.beforeEach((to, from, next) => {
    const NODE_ENV =  process.env.VUE_APP_CURENV;
    if (window._hmt && NODE_ENV === "production") {
        if (to.path) {
            window._hmt.push(['_trackPageview', '/#' + to.fullPath]);
        }
    }
    next();
});
router.afterEach(() => {
    window.scrollTo(0, 0);
});

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
